// @jsx h

/* global __HOT__ */

import { createUniqueId, toArray } from '@nrk/dh-utils'
import { testPositionSticky } from '@nrk/feature-tests'
import domready from 'domready'
import { sendEvent } from 'google-analytics'
import { h, render } from 'preact'

// Import CSS
import '@nrk/dh-feature-components/dist/module/Byline/index.css'
import '@nrk/dh-feature-components/dist/module/Figure/index.css'
import '@nrk/dh-feature-components/dist/module/Heading/index.css'
import '@nrk/dh-feature-components/dist/module/List/index.css'
import '@nrk/dh-feature-components/dist/module/Paragraph/index.css'
import '@nrk/dh-feature-components/dist/module/Slideshow/index.css'
import style from './client.css'

window[style.root] = window[style.root] || {}

domready(init)

function init () {
  findElements().forEach(el => {
    el.id = createUniqueId(10, '_')

    window[style.root][el.id] = true

    cutTheMustard(hasSupport => {
      if (hasSupport) {
        el.className = el.className.replace('noJs', 'js')

        // Extract preloaded state sent from server
        const preloadedState = JSON.parse(
          el.getAttribute('data-preloaded-state')
        )

        // ... and render with the exact same props
        renderApp(el, preloadedState)

        // Enable webpack hot-reloading
        if (__HOT__) {
          // Reload and re-render React application
          module.hot.accept('./client', () => {
            renderApp(el, preloadedState)
          })
        }
      } else {
        // NO SUPPORT
      }
    })
  })
}

function handleAnalyticsEvent (analyticsEvent = {}) {
  if (typeof analyticsEvent.action === 'string') {
    sendEvent({
      category: 'dh-spesial',
      action: analyticsEvent.action,
      label: 'Spesial – Trygdekontoret – Trylling'
    })
  }
}

function findElements () {
  return toArray(document.getElementsByClassName(style.root)).filter(
    el => !isInitialized(el)
  )
}

function cutTheMustard (callbackFn) {
  return testPositionSticky(callbackFn)
}

function renderApp (el, props) {
  const Article = require('./components/Article').default
  render(
    <Article {...props} onAnalyticsEvent={handleAnalyticsEvent} />,
    el,
    el.firstChild
  )
}

function isInitialized (el) {
  return el.id && window[style.root][el.id]
}
